var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortDescChevrons = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.75L9 14.5625L6.1875 11.75",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 11.75L9 14.5625L6.1875 11.75H11.8125Z",
    stroke: "#111827",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.0625L9 4.25L11.8125 7.0625",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.0625L9 4.25L11.8125 7.0625L6.1875 7.0625Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortDescChevrons);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-desc-chevrons.ad92d51ce23ea1b6df970db416c59229.svg";